import { render, staticRenderFns } from "./More.vue?vue&type=template&id=4131598e&scoped=true&"
import script from "./More.vue?vue&type=script&lang=ts&"
export * from "./More.vue?vue&type=script&lang=ts&"
import style0 from "./More.vue?vue&type=style&index=0&id=4131598e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4131598e",
  null
  
)

export default component.exports